import { Link } from 'react-router-dom';
import { Header3 } from 'components/UI/Brand/text';
import { AlertBox, LinkText } from 'components';
import CustomImage from 'components/UI/CustomImage/CustomImage';
import { IGeneralSection } from 'interfaces/IMarketing';
import ArrowSearchLink from 'components/UI/Links/ArrowSearchLink';
import ContentfulRenderer from 'components/ContentfulRenderer';
import { HEADER_SIZE } from './utils/getHeader.util';
import styles from './styles.module.scss';

interface ITopSectionA {
  article: IGeneralSection;
  highestHeadingSize?: HEADER_SIZE;
}

const TopSectionA = ({
  article,
  highestHeadingSize = HEADER_SIZE.H1,
}: ITopSectionA) => (
  <div className={styles.topSectionA} id={article.title}>
    <div className={styles.textContainer}>
      {article.title && (
        <Header3 as="h2" className={styles.title}>
          {article.title}
        </Header3>
      )}
    </div>
    <div className={styles.imageContainer}>
      {article.media && (
        <CustomImage
          className={styles.image}
          src={article.media}
          alt={article.title}
          width={752}
          height={410}
        />
      )}
    </div>
    <div className={styles.textContainer}>
      <ContentfulRenderer highestHeadingSize={highestHeadingSize}>
        {article.longDescription}
      </ContentfulRenderer>
      {article.link &&
        (article.link.type === 'hyperlink' ||
          article.link.type === 'articleContainerLink') && (
          <LinkText
            className={styles.label}
            to={article.link.hyperlink}
            as={Link}
          >
            {article.link.title}
          </LinkText>
        )}
      {article.link && article.link.type === 'search criteria' && (
        <div className={styles.linkWithArrowContainer}>
          <ArrowSearchLink link={article.link} />
        </div>
      )}
    </div>
    {article.infoBox && (
      <AlertBox type="info" OverrideIcon=" " className={styles.infoBox}>
        <ContentfulRenderer highestHeadingSize={highestHeadingSize}>
          {article.infoBox}
        </ContentfulRenderer>
      </AlertBox>
    )}
  </div>
);

export default TopSectionA;
